export default "__VITE_ASSET__BIz9Do0Y__"